<template>
  <div v-if="text"
       class="seo">
    <div v-html="text"
         class="seo__text  text"></div>
  </div>
</template>

<script>
  import {http} from '../axios';

  export default {
    props: {
      link: String
    },
    data() {
      return {
        text: null
      }
    },
    methods: {
      load() {
        if (!this.link) {
          this.text = null
          return
        }

        this.pending = true

        return http.get(`/api/helper/seo-text`, {
          params: {
            url: this.link
          }
        }).then(({data}) => {
          this.text = data.data
        }).finally(() => {
          this.pending = false
        })
      }
    },
    created() {
      this.load()
    },
    watch: {
      link() {
        this.load()
      }
    }
  }
</script>

<style lang="less">

</style>
